import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'counter']
  static values = { max: Number }

  connect () {
    this.cCounter = this.update()
    document.addEventListener('turbo:morph', this.reconnect.bind(this))
  }

  disconnect () {
    this.cCounter = undefined
  }

  update () {
    const length = this.inputTarget.value.length
    this.counterTarget.textContent = `${length}/${this.maxValue}`
  }

  reconnect () {
    this.disconnect()
    this.connect()
  }
}
